(function() {

    const app = angular.module('TetherApp');

    let CampaignReportingController = function (
        $window,
        $controller,
        broadcastService,
        campaignService
    ) {
        let self = this;

        self.listController = $controller('ListController');

        self.clientEid = {};
        self.campaignEid = undefined;
        self.last_filter_date = 'Month';
        self.filter_date = 'Month';
        self.start_date = new Date();
        self.end_date = new Date();

        self.onFilterDateChange = function () {
            if (self.filter_date === 'Custom') {
                self.start_date = new Date();
                self.end_date = new Date();

                if (self.last_filter_date === 'Week') {
                    self.start_date.setDate(self.start_date.getDate() - 7);
                }
                if (self.last_filter_date === 'Month') {
                    self.start_date.setMonth(self.start_date.getMonth() - 1);
                }
            } else {
                self.last_filter_date = self.filter_date;
                self.updateStats();
                self.updateGraph();
            }
        };

        self.onDateChange = function () {
            self.updateStats();
            self.updateGraph();
        };

        self.loadStats = function (clientEid, campaignEid) {
            self.clientEid = clientEid;
            self.campaignEid = campaignEid;

            self.updateStats();
			self.updateGraph();
        };

        self.updateGraph = function () {
            let parameters = { filter_date: self.filter_date };

            if (self.filter_date === 'Custom') {
                parameters.start = self.start_date;
                parameters.end = self.end_date;
            }

            campaignService.graph(self.clientEid, self.campaignEid, parameters)
                .then(onCampaignGraph, onError);
        };

        const onCampaignGraph = function (data) { self.graph = data; };

        self.updateStats = function () {
            let parameters = { filter_date: self.filter_date };

            if (self.filter_date === 'Custom') {
                parameters.start = self.start_date;
                parameters.end = self.end_date;
            }

            campaignService.stats(self.clientEid, self.campaignEid, parameters)
                .then(onStats, onError);
        };

		const onStats = function (data) { self.stats = data; };

        self.cancelBroadcast = function (id) {
            if ($window.confirm(self.cancelText)) {
                broadcastService.cancelBroadcast(id).then(onCancel, onError);
            }
        };

        let onCancel = function () {
            if (self.campaignId !== undefined) {
                self.updateStats(self.campaignId);
            } else {
                $window.location.reload();
            }
        };

        let onError = function () { /* TODO: should do something... */ };
    };

    angular.module('TetherApp').controller('CampaignReportingController', [
        '$window',
        '$controller',
        'broadcastService',
        'campaignService',
        CampaignReportingController
    ]);
}());
